// This file is auto-generated by update-translation-configuration script.
// Don't edit it manually, instead run `npm run update-translation-configuration`.

import adminApiTokensTranslations from '@/admin/api-tokens/i18n/translations.en-GB.json';
import adminBillingTranslations from '@/admin/billing/i18n/translations.en-GB.json';
import adminBrandingTranslations from '@/admin/branding/i18n/translations.en-GB.json';
import adminCategoriesTranslations from '@/admin/categories/i18n/translations.en-GB.json';
import adminCoursesTranslations from '@/admin/courses/i18n/translations.en-GB.json';
import adminEventsTranslations from '@/admin/events/i18n/translations.en-GB.json';
import adminGroupsTranslations from '@/admin/groups/i18n/translations.en-GB.json';
import adminTranslations from '@/admin/i18n/translations.en-GB.json';
import adminPlaylistsTranslations from '@/admin/playlists/i18n/translations.en-GB.json';
import adminSettingsTranslations from '@/admin/settings/i18n/translations.en-GB.json';
import adminSkillsTranslations from '@/admin/skills/i18n/translations.en-GB.json';
import adminTopicsTranslations from '@/admin/topics/i18n/translations.en-GB.json';
import adminUsersTranslations from '@/admin/users/i18n/translations.en-GB.json';
import authenticationTranslations from '@/authentication/i18n/translations.en-GB.json';
import commonComponentsTranslations from '@/common/components/i18n/translations.en-GB.json';
import commonTranslations from '@/common/i18n/translations.en-GB.json';
import contentStoreTranslations from '@/content-store/i18n/translations.en-GB.json';
import coursesTranslations from '@/courses/i18n/translations.en-GB.json';
import eventsTranslations from '@/events/i18n/translations.en-GB.json';
import notificationsTranslations from '@/notifications/i18n/translations.en-GB.json';
import openInAppTranslations from '@/open-in-app/i18n/translations.en-GB.json';
import profileSettingsTranslations from '@/profile-settings/i18n/translations.en-GB.json';
import reportingCommonTranslations from '@/reporting/i18n/common/translations.en-GB.json';
import reportingCourseReportTranslations from '@/reporting/i18n/course-report/translations.en-GB.json';
import reportingSegmentsTranslations from '@/reporting/i18n/segments/translations.en-GB.json';
import reportingSkillsReportTranslations from '@/reporting/i18n/skills-report/translations.en-GB.json';
import reportingUserGroupsReportTranslations from '@/reporting/i18n/user-groups-report/translations.en-GB.json';
import reportingUserReportTranslations from '@/reporting/i18n/user-report/translations.en-GB.json';

import { mergeTranslations } from '@/common/services';

export default mergeTranslations(
    adminApiTokensTranslations,
    adminBillingTranslations,
    adminBrandingTranslations,
    adminCategoriesTranslations,
    adminCoursesTranslations,
    adminEventsTranslations,
    adminGroupsTranslations,
    adminTranslations,
    adminPlaylistsTranslations,
    adminSettingsTranslations,
    adminSkillsTranslations,
    adminTopicsTranslations,
    adminUsersTranslations,
    authenticationTranslations,
    commonComponentsTranslations,
    commonTranslations,
    contentStoreTranslations,
    coursesTranslations,
    eventsTranslations,
    notificationsTranslations,
    openInAppTranslations,
    profileSettingsTranslations,
    reportingCommonTranslations,
    reportingCourseReportTranslations,
    reportingSegmentsTranslations,
    reportingSkillsReportTranslations,
    reportingUserGroupsReportTranslations,
    reportingUserReportTranslations
);
